export type _ElevationLevels = 1 | 2 | 3 | 4;

export default function Elevation(elevation: _ElevationLevels): string {
  const y = elevation;
  const blur = 2 ** (1 + elevation); // 4, 8, 16, 32....

  const alpha = 22 - 2 * elevation;
  return `box-shadow: 0 ${y}px ${blur}px rgba(0, 0, 0, 0.${alpha});`;
}



// WEBPACK FOOTER //
// ../kibble/styles/Elevation.ts